import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getWhishlistService } from "../services/addToWishlistservices";
import { removeFromWishlistService } from "../services/removeFromWishlist";

// Async thunk to fetch wishlist data
export const fetchWishlist = createAsyncThunk(
  "wishlist/fetchWishlist",
  async (_, thunkAPI) => {
    try {
      const response = await getWhishlistService();

      return response.data; // Return the data if it exists
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "Failed to fetch Wishlist"
      );
    }
  }
);

// Async thunk to remove an item from the wishlist
export const removeWishItem = createAsyncThunk(
  "wishlist/removeWishItem",
  async (product_id, thunkAPI) => {
    try {
      const response = await removeFromWishlistService(product_id);
      return product_id; // Return the product ID to remove it from the state
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "Failed to remove item from Wishlist"
      );
    }
  }
);

const getWishlistSlice = createSlice({
  name: "wishlist",
  initialState: {
    likedItems: [],
    totalAmount: 0,
    deliveryCharges: 0,
    couponDiscount: 0,
    netAmount: 0,
    loading: false,
    error: null,
  },
  reducers: {
    removeItemFromWishlist: (state, action) => {
      state.likedItems = state.likedItems.filter(
        (item) => item.id !== action.payload
      );
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchWishlist.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchWishlist.fulfilled, (state, action) => {
        state.loading = false;
        const data = action.payload || {};

        // Setting the liked items from the response data
        state.likedItems = data.map((item) => ({
          id: item.id,
          in_cart: item.in_cart,
          title: item.title,
          description: item.description,
          mrp: item.mrp,
          sales_price: item.sales_price,
          image: item.image,
        }));

        state.totalAmount = data.total_amount || 0;
        state.deliveryCharges = data.delivery_charges || 0;
        state.couponDiscount = data.coupon_discount || 0;
        state.netAmount = data.net_amount || 0;
      })
      .addCase(fetchWishlist.rejected, (state, action) => {
        state.loading = false;
        const err = action.payload;
        state.error =
          (err && err.message) ||
          (typeof err === "string" ? err : null) ||
          "Failed to fetch wishlist";
      })

      .addCase(removeWishItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeWishItem.fulfilled, (state, action) => {
        state.loading = false;
        const removedItemId = action.payload;
        state.likedItems = state.likedItems.filter(
          (item) => item.id !== removedItemId
        );
      })
      .addCase(removeWishItem.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { removeItemFromWishlist } = getWishlistSlice.actions;

export default getWishlistSlice.reducer;
